import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="legal-page" data-testid="terms-page">
      <div className="legal-container">
        <Link to="/" className="back-link">
          <ArrowLeft size={20} />
          Back to Home
        </Link>
        
        <h1>Terms of Conditions</h1>
        <p className="legal-updated">Last Updated: February 2026</p>

        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using QMDJ.live ("the Service"), you accept and agree to be bound by these Terms of Conditions. 
            If you do not agree to these terms, please do not use the Service.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Description of Service</h2>
          <p>
            QMDJ.live provides Qi Men Dun Jia chart calculation and visualization services. The Service allows users to view, 
            upload, and manage Qi Men Dun Jia charts for personal and educational purposes.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. User Accounts</h2>
          <p>
            To access certain features of the Service, you may be required to register for an account. You agree to:
          </p>
          <ul>
            <li>Provide accurate and complete registration information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Notify us immediately of any unauthorized use of your account</li>
            <li>Accept responsibility for all activities that occur under your account</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. User Content</h2>
          <p>
            You retain ownership of any content you upload to the Service. By uploading content, you grant us a non-exclusive, 
            worldwide license to use, store, and display your content for the purpose of providing the Service.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Prohibited Uses</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for any unlawful purpose</li>
            <li>Upload malicious content or files</li>
            <li>Attempt to gain unauthorized access to the Service</li>
            <li>Interfere with or disrupt the Service</li>
            <li>Resell or redistribute the Service without authorization</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are owned by QMDJ.live and are protected by 
            international copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Disclaimer of Warranties</h2>
          <p>
            The Service is provided "as is" without warranties of any kind. We do not guarantee the accuracy of Qi Men Dun Jia 
            calculations or interpretations. The Service is for informational and educational purposes only and should not be 
            used as the sole basis for making important decisions.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            In no event shall QMDJ.live be liable for any indirect, incidental, special, consequential, or punitive damages 
            arising from your use of the Service.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of significant changes by posting 
            a notice on the Service. Continued use after changes constitutes acceptance of the new Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Contact Information</h2>
          <p>
            For questions about these Terms, please contact us at support@qmdj.live
          </p>
        </section>

        <footer className="legal-footer">
          <p className="footer-copyright">Copyright © 2026 Steven Yong - Digital Dive Coaching Sdn. Bhd. All rights reserved worldwide.</p>
        </footer>
      </div>
    </div>
  );
}
